import React, { useMemo, useRef } from 'react'

import { Favorite_PageIdEnum } from 'src/api/gen'
import { useURLAndStorageState } from 'src/commons/hooks/useURLAndStorageState'
import { IFilters } from 'src/commons/types'
import { useAgencySettings, useAgencySettingsDistanceUnit, useAgencySettingsSpeedUnit } from 'src/layout/AgencySettings'
import { useProviders } from 'src/layout/hooks'
import { useMapLayer } from 'src/layout/MapLayerWrapper'
import { FilteringCard } from 'src/muiv5/components/commons/Cards/FilteringCard'
import { getInitialFilters } from 'src/pages/Dashboard'
import EnvironmentCharts from 'src/pages/Dashboard/EnvironmentCharts'
import DashboardFilterPanel from 'src/pages/Dashboard/FilterPanel'

export default function TripsEnvKPI() {
  const { activeProviders } = useProviders()
  const layers = useMapLayer()
  const { get_kpi_filter_range } = useAgencySettings()
  const { value: speedUnit } = useAgencySettingsSpeedUnit()
  const { value: distanceUnit } = useAgencySettingsDistanceUnit()
  const isDurationFilterEnabled = true
  const defaultFilters = useMemo(
    () =>
      getInitialFilters(layers, get_kpi_filter_range, isDurationFilterEnabled, distanceUnit, speedUnit, false, true),
    [layers, get_kpi_filter_range, isDurationFilterEnabled, distanceUnit, speedUnit]
  )
  const [filters, setFilters] = useURLAndStorageState(Favorite_PageIdEnum.trips_env_KPI, defaultFilters, [
    'range',
    'endRange',
  ])
  const displayedFiltersRef = useRef<IFilters>()

  const onApplyFilter = function () {
    if (!displayedFiltersRef.current) {
      throw new Error('There are no displayed filters')
    }

    setFilters(displayedFiltersRef.current)
  }

  return (
    <FilteringCard
      SideComponent={
        <DashboardFilterPanel
          ref={displayedFiltersRef}
          initialFilters={filters}
          defaultFilters={defaultFilters}
          providers={activeProviders}
        />
      }
      onApplyFilter={onApplyFilter}
    >
      <EnvironmentCharts filters={filters} />
    </FilteringCard>
  )
}
